import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-modal-lock',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './generic-modal-lock.component.html',
  styleUrls: ['./generic-modal-lock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericModalLockComponent {}
